import { Injectable } from '@angular/core';
import { AbstractService } from './abstract_service.service';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ResponseGroupService extends AbstractService {
    path = 'responseGroup';

    getLatestUserResponse (
        pathSegments: string[],
        queryParameters: Map<string, any>
    ): Observable<any> {
        const pathSegmentString = this._buildPathSegments(pathSegments);
        const queryParameterString =
            this._buildQueryParameters(queryParameters);

        return this.http.get<any>(
            `${this.baseUrl}/${this.path}${pathSegmentString}${queryParameterString}`,
            this.httpOptions
        );
    }
}